module.exports = __webpack_public_path__ + "img/step-icon-evaluation.e6d22c08.svg";